import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import SkeletonGrid from '../../../../components/SkeletonLoader/SkeletonGrid';
import DropDownSelect from '../../../../../src/components/DropDownSelect/index';
import DropDownScroll from '../../../../../src/components/DropDownScroll/index';
import { useReportContext } from '../../components/reportContext';
import {
  useGetAssignmentCoursesMutation,
  useGetAssignmentStudentsListMutation,
  useGetAssignmentClassesMutation
} from '../../../../features/authentication/reportApiSlice';
import { useNavigate } from 'react-router';
import CustomToast from '../../../../components/Toast';

const LoginTrackingFilter = () => {
  let takeSize = 30;
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [assignments, setAssignments] = useState([]);

  const [getAssignmentsAndCourses] = useGetAssignmentCoursesMutation();
  const [getAssignmentStudents] = useGetAssignmentStudentsListMutation();
  const [getAssignmentClasses] = useGetAssignmentClassesMutation();
  const navigate = useNavigate();

  const [dateBasedKey, setDateBasedKey] = React.useState(new Date().getTime().toString());
  const [initial, setInitial] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [skip, setSkip] = useState(0);
  const [searchString, setSearchString] = useState('');
  const [assignmentName, setAssignmentName] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const { assignmentId, setAssignmentId, selectedClassId, setSelectedClassId, selectedStudentId, setSelectedStudentId,
    studentName, setStudentName, studentToIncludeTab, setStudentToIncludeTab, className, setClassName } = useReportContext();

  useEffect(() => {
    getReportFilterData();
    getAssignmentClassesAsync();
  }, []);

  useEffect(() => {
    setSearchString('');
    setStudents([]);
    setSelectedStudentId(0);
    setStudentName('');
    setDateBasedKey(new Date().getTime().toString());
    if (studentToIncludeTab == 2) {
      getAssignmentStudentsAsync(assignmentId, 0, takeSize, true, []);
    }
    else if (studentToIncludeTab == 1) {
      getAssignmentClassesAsync();
    }
    else
      setSelectedStudentId(-1);
  }, [assignmentId]);

  const getReportFilterData = async () => {
    setIsLoading(true);
    const option = {
      isAssessment: false,
      getOnlyTimeOnTask: true,
      isLoginReport: true
    };
    var response = await getAssignmentsAndCourses(option).unwrap();
    const obj = {
      id: -1,
      name: 'All Assignments'
    };
    const assignmentsArray = [obj, ...response.assignments];
    setAssignments(assignmentsArray);
    setAssignmentId(assignmentsArray[0].id);
    setAssignmentName(assignmentsArray[0].name);
    setIsLoading(false);
    setInitial(false);
  };

  const getAssignmentClassesAsync = async () => {
    const options = {
      assignmentId: -1,
      isAssessment: false,
      getOnlyTimeOnTask: true,
      isLoginReport: true
    };
    var classes = await getAssignmentClasses(options).unwrap();
    const obj = {
      id: -1,
      name: 'All Classes'
    };
    const classArray = [obj, ...classes];
    setClasses(classArray);
    const selectedClass = classArray.find(x => x.id == selectedClassId);
    if (selectedClass)
      setClassName(selectedClass.name);
  };

  const handleTabSwitch = (tab) => {
    setSelectedClassId(-1);
    setClassName('All Classes');
    if (tab == 2) {
      setStudentToIncludeTab(2);
      getAssignmentStudentsAsync(assignmentId, 0, takeSize, true, []);
    }
    else if (tab == 0) {
      setSelectedStudentId(-1);
      setStudentToIncludeTab(0);
    }
    else {
      setSelectedStudentId(0);
      setStudentToIncludeTab(1);
      getAssignmentClassesAsync();
    }
  };
  const getAssignmentStudentsAsync = async (assignmentId, skip, take, hasMore, students) => {
    if (hasMore) {
      setIsLoading(true);
      const options = {
        assignmentId: assignmentId,
        skip: skip,
        take: take,
        isAssessment: false,
        getOnlyTimeOnTask: true,
        searchString: searchString,
        isLoginReport: true
      };
      var response = await getAssignmentStudents(options).unwrap();
      setHasMore((skip + take) < response.total);
      if (response.data?.length > 0) {
        var newStudents = [...students, ...response.data];
        setStudents(newStudents);
      }
      else {
        const noResults = [{ id: -2, name: 'No results found' }];
        setStudents(noResults);
        setSelectedStudentId(0);
        setStudentName('');
      }
      setIsLoading(false);
    }
  };

  const loadMoreData = () => {
    if (!initial && hasMore) {
      const skipValue = skip + takeSize;
      getAssignmentStudentsAsync(assignmentId, skipValue, takeSize, hasMore, students);
      setSkip(skipValue);
    }
  };

  const handleReportPage = () => {
    if(studentToIncludeTab == 2 && selectedStudentId <= 0){
      CustomToast('Please select a student to create report.','error');
      return;
    }
    navigate('activity-report');
  };

  return (
    <>
      <div className='white-card'>
        <div className='align-items-center d-flex justify-content-between mb-4'>
          <h1 className='mb-4'>Login Tracking Report</h1>
          <div>
            <button
              onClick={() => window.history.back()}
              className="btn btn-castleWhite report-btn">
              Back
            </button>
          </div>
        </div>
        <p>Login Tracking reports on student login, logout and idle times. Idle time is any 1 minute period where no mouse or keyboard activity takes place minus any time a student was actively working on a question for a time on task assignment.</p>
        <strong><label className='mr-1'>Time Period:</label></strong><span>This report displays data for the past 15 days.</span>
        {isLoading ? (
          <SkeletonGrid
            rowCount={1}
            colCount={3}
            className={'mt-5 p-2'} />
        ) : (
          <>
            <Row className='mt-4'>
              <Col className='col-4 px-2'>
                <Row>
                  <Col>
                    <label className='mb-2'>Students To Include</label>
                  </Col>
                </Row>
                <Row className="d-flex align-items-center blueTabs w-100 mx-0">
                  <Col className={`justify-content-center btn ${studentToIncludeTab == 2 ? 'active' : ''}`} onClick={() => handleTabSwitch(2)}>Single Student</Col>
                  <Col className={`justify-content-center btn ${studentToIncludeTab == 0 ? 'active' : ''}`} onClick={() => handleTabSwitch(0)}>All Students</Col>
                  <Col className={`justify-content-center btn ${studentToIncludeTab == 1 ? 'active' : ''}`} onClick={() => handleTabSwitch(1)}>Students in Class</Col>
                </Row>
              </Col>
              <Col className='col-4 px-2'>
                <label className='mb-2'>Assignment</label>
                <DropDownSelect
                  value={assignments}
                  selectedId={assignmentId}
                  setSelectedId={setAssignmentId}
                  dropdownId="assignmentList"
                  selectedName={assignmentName}
                  setSelectedName={setAssignmentName}
                />
              </Col>
              {studentToIncludeTab == 0 &&
                <Col className='col-4 px-2'>
                </Col>}
              {studentToIncludeTab == 2 &&
                <Col className='col-4 px-2'>
                  <label className='mb-2'>Student</label>
                  <DropDownScroll
                    key={dateBasedKey}
                    value={students}
                    selectedId={selectedStudentId}
                    setSelectedId={setSelectedStudentId}
                    dropdownId="studentList"
                    selectedName={studentName}
                    setSelectedName={setStudentName}
                    loadMoreData={loadMoreData}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    setSearchString={setSearchString}
                  />
                </Col>
              }
              {studentToIncludeTab == 1 &&
                <Col className='col-4 px-2'>
                  <label className='mb-2'>Class</label>
                  <DropDownSelect
                    value={classes}
                    selectedId={selectedClassId}
                    setSelectedId={setSelectedClassId}
                    dropdownId="classList"
                    selectedName={className}
                    setSelectedName={setClassName}
                  />
                </Col>
              }
            </Row>
          </>
        )}
        <div className='w-100 d-flex gap-3 mt-4'>
          <div className='w-100'></div>
          <button className="w-10 btn btn-castleRed" onClick={() => handleReportPage()}>
            Create Report
          </button>
        </div>
      </div>
    </>
  );
};


export default LoginTrackingFilter;